import React, {useState, memo, useEffect, useMemo, useCallback} from 'react';
import Switch from 'react-switch';
import S from 'StyledBetSlipPromotions.js';
import _map from 'lodash/map';
import _get from 'lodash/get';
import _find from 'lodash/find';
import _size from 'lodash/size';
import _filter from 'lodash/filter';
import { Scrollbars } from 'react-custom-scrollbars';
import useMediaQuery from 'react-use-media-query-hook';
import {translation} from 'utilsHelper';

const OFFER_TYPE_TAX_FACTOR_PROMOTION = "TAX_FACTOR_PROMOTION";
const ALLOWED_SLIP_TYPES = [
    "ACCUMULATOR",
    "MULTICOUPON",
];

const BetSlipPromotions = ({
    togglePromotion, 
    selectedPromotion, 
    slipType, 
    hasApprovalButtonsVisibled, 
    getCustomerBetSlipPromotions, 
    promotions, 
    placed, 
    slipId,
    submitDisabled,
}) => {
    const isSmallDesktop = useMediaQuery('(max-width: 1440px)');
    const [betSlipPromotions, setBetSlipPromotions] = useState(null);

    useEffect(() => {
        getCustomerBetSlipPromotions();
    }, [placed, slipId, slipType]);

    useEffect(() => {
        let customerPromotions = promotions?.filter((promo) => promo.offerType === OFFER_TYPE_TAX_FACTOR_PROMOTION) ?? [];
        if (slipType === "MULTICOUPON") {
            customerPromotions = customerPromotions.filter((promo) => promo.multiCouponSizes?.length > 0)
        }
        setBetSlipPromotions(customerPromotions);
    }, [promotions, slipType]);

    const toggleSelectedPromotion = (offerId) => {
        const item = _find(betSlipPromotions, {offerId});
        togglePromotion(item);
    };

    const isVisible = useMemo(() => {
        if (betSlipPromotions?.length === 0) return false;
        return ALLOWED_SLIP_TYPES.includes(slipType);
    }, [slipType, betSlipPromotions]);

    return (
        <S.BetSlipPromotionsWrapper isVisible={isVisible}>
            <S.BetSlipPromotions isSmallDesktop={isSmallDesktop}>
                <Scrollbars
                    renderTrackHorizontal={props => <div {...props} style={{display: 'none'}} className="track-horizontal"/>}
                    style={{width: '100%'}}
                    autoHeight
                    autoHeightMax={(isSmallDesktop ? 50 : 100)}>

                    {betSlipPromotions?.map(({offerId, offerNameKey}) => {
                        const selectedPromotionId = _get(selectedPromotion, ['offerId']);
                        return (
                            <S.BetSlipPromotionsItem 
                                key={offerId} 
                                isActive={offerId == selectedPromotionId}
                            >
                                <span>
                                    <S.PromotionName data-translation={offerNameKey}>
                                        {translation(offerNameKey)}
                                    </S.PromotionName>
                                </span>&nbsp;&nbsp;
                                <Switch 
                                    height={20}
                                    width={40}
                                    disabled={hasApprovalButtonsVisibled || submitDisabled}
                                    onChange={() => toggleSelectedPromotion(offerId)}
                                    checked={offerId == selectedPromotionId}
                                />
                            </S.BetSlipPromotionsItem>
                        )
                    })}
                </Scrollbars>
            </S.BetSlipPromotions>
        </S.BetSlipPromotionsWrapper>
    );
};

export default memo(BetSlipPromotions);
